import { render, staticRenderFns } from "./ListDistrictTypePage.vue?vue&type=template&id=917d7dfa&"
import script from "./ListDistrictTypePage.vue?vue&type=script&lang=js&"
export * from "./ListDistrictTypePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports